/**
 * Leep Chás — focus trap for modals and drawers (WCAG)
 */
(function () {
  const FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  window.LeepFocusTrap = {
    activate(container) {
      if (!container) return () => {};

      const getFocusable = () =>
        [...container.querySelectorAll(FOCUSABLE)].filter(
          (el) => !el.closest('[hidden]') && el.offsetParent !== null && !el.hasAttribute('disabled')
        );

      const onKeyDown = (event) => {
        if (event.key !== 'Tab') return;
        const items = getFocusable();
        if (items.length < 2) return;

        const first = items[0];
        const last = items[items.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };

      container.addEventListener('keydown', onKeyDown);

      return () => {
        container.removeEventListener('keydown', onKeyDown);
      };
    },
  };
})();
